import { render, staticRenderFns } from "./ViewerCurrentDetail.vue?vue&type=template&id=648981d4"
import script from "./ViewerCurrentDetail.vue?vue&type=script&lang=js"
export * from "./ViewerCurrentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports